import axios from 'axios';
import config from './server.js'
import url from './url.js'
import DEBUG from './debug.js'
import { toast } from 'react-toastify';

/**
|--------------------------------------------------
| This function is ussed for load first data. and only specifically for type method get
| this module was specifically made to `CANCEL THE REQUEST IF COMPONENT WILL UNMOUNT`.
|
|   "Warning: Can’t call setState (or forceUpdate) on an unmounted component. 
|    This is a no-op, but it indicates a memory leak in your application. 
|    To fix, cancel all subscriptions and asynchronous tasks in the componentWillUnmount method."
|
| for more detail about it. you can try learn on this article.
| https://medium.freecodecamp.org/how-to-work-with-react-the-right-way-to-avoid-some-common-pitfalls-fc9eb5e34d9e
|--------------------------------------------------
*/
export const RequestAsync = async (url_key, headers={}, data={}, myCancelToken) => {
  if (typeof headers !== "object") {
    throw new Error("Invalid headers, headers must be an object")
  }

  let api = url[url_key]
  if (!api) {
    throw new Error("Invalid url key")
  }

  if (typeof data !== "object") {
    throw new Error("Invalid data, data must be an object")
  }

  for (let header in headers) {
    axios.defaults.headers.common[header] = headers[header]
  }

  try {
    const response  = await axios.get(config.ATM_CLOUD.API + api, {
      params:data,
      cancelToken: myCancelToken,
    })
    return response;
  } catch (error) {
    if (axios.isCancel(error)) {
      DEBUG && console.log('Warning: Request to Api is being canceled by user!')
    } else {
      if(error) {
        if(error.response) {
          if(error.response.data){
            if(typeof error.response.data === "object") {
              if(error.response.data.hasOwnProperty('detail')) {
                toast.error(error.response.data.detail)
              } else {
                toast.error('Something went wrong')
              }
            } else {
              toast.error("Wrong return from server")
            }
          }
        }
      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/App/config/RequestAsync.js